var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 294,
    viewBox: "0 0 168 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.085 139.5C119.185 120.9 95.7852 109.8 71.7852 109.5C51.0852 109.2 31.2852 116.7 20.7852 125.7V16.2H140.785V0.299988H4.88516V165.3L18.6852 149.4C32.7852 133.5 51.0852 125.4 71.7852 125.4C91.5852 125.4 109.885 134.1 122.785 149.4C150.685 182.4 147.385 234.3 115.585 261.6C101.185 274.2 83.4852 279.9 64.5852 277.5C44.7852 274.8 27.6852 264.6 13.8852 245.1L0.985157 254.4C17.1852 276.9 39.0852 290.4 62.7852 293.1C66.0852 293.7 69.6852 293.7 72.6852 293.7C92.1852 293.7 111.085 286.8 126.385 273.9C163.585 241.2 167.785 178.2 135.085 139.5Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber5);
export default __webpack_public_path__ + "static/media/NUMBER_5.2851f1d5953f0bfdc68d8648a9c77559.svg";
export { ForwardRef as ReactComponent };